<p-dialog [(visible)]="displayModalSuspend" [modal]="true" [style]="{width: '30vw'}"
          [draggable]="false" [resizable]="false" (onHide)="cancel()">
    <div class="m-0 suspend-body">
        <img src="../Content/xpress-app/images/illustration_suspend.png" />
        <p class="suspend-title">Suspend merchant</p>
        <p class="suspend-description">Choose how long you want to suspend <span class="suspend-username">{{merchant.PartnerName}}</span></p>
        <p class="suspend-dropdown">
            <p-inputNumber [(ngModel)]="merchant.SuspendUntilDays" suffix=" days" [ngStyle]="{'width': '70%;'}" [min]="1" [max]="36500"></p-inputNumber>
        </p>
    </div>
    <div class="flex justify-content-center mt-20">
        <div>
            <button pButton pRipple type="button" label="Cancel" class="p-button-secondary btn-cancel" (click)="displayModalSuspend = false"></button>
        </div>
        <div>
            <button [disabled]="loading" pButton pRipple type="button" label="Suspend" class="p-button-outlined p-button-warning btn-suspend" (click)="saveSuspend(true)"></button>
        </div>
        <div>
            <button [disabled]="!activeResumeButton || loading" pButton pRipple type="button" label="Resume" class="p-button-outlined p-button-success btn-resume" (click)="saveSuspend(false)"></button>
        </div>
    </div>
</p-dialog>
<p-toast></p-toast>
